var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.832 40a.68.68 0 0 1-.304-.078c-.289-.154-.44-.51-.371-.865l3.059-15.48-6.767-2.859a.756.756 0 0 1-.428-.525.884.884 0 0 1 .137-.695L14.645.279c.206-.279.55-.355.827-.2.289.153.44.51.371.865l-3.059 15.48 6.767 2.858a.756.756 0 0 1 .428.525.884.884 0 0 1-.137.696L5.355 39.737a.679.679 0 0 1-.523.263z",
    fillRule: "evenodd"
  })));
};

export default SvgBolt;